module.exports = __webpack_public_path__ + "img/Med04.03-1-VAC.d1882d47.jpg";